// Auto-extracted from uploaded files. Kept original logic.
export default function bufferExtent(extent) {
    var diff20 = (extent[2] - extent[0]) / 10;
    var diff31 = (extent[3] - extent[1]) / 10;
    extent.forEach((number, ind) => {
        if (ind == 0) {
            extent[ind] = number - diff20;
        } else if (ind == 1) {
            extent[ind] = number - diff31;
        } else if (ind == 2) {
            extent[ind] = number + diff20;
        } else if (ind == 3) {
            extent[ind] = number + diff31;
        }
    });
    return extent;
}
